"use strict";
/**
 * @author yyy
 */


// 扩展原生filter
if(!Array.prototype.filter)
    Array.prototype.filter =  function(fn, context){
      var result = [];
        for (var i = 0, len = this.length; i < len; i++){
          if ((i in this) && fn.call(context, this[i], i, this)){
            result.push(this[i]);
          }
        }
        return result;
    }

if (!Array.prototype.forEach){  
    Array.prototype.forEach = function(fun){  
        var len = this.length;  
        var thisp = arguments[1];  
        for (var i = 0; i < len; i++)  
        {  
            if (i in this)  
                fun.call(thisp, this[i], i, this);  
        }  
    };  
}  
// 类数组
function _isArrayLike(o) {
    if (o &&                                // o is not null, undefined, etc.
        typeof o === 'object' &&            // o is an object
        isFinite(o.length) &&               // o.length is a finite number
        o.length >= 0 &&                    // o.length is non-negative
        o.length===Math.floor(o.length) &&  // o.length is an integer
        o.length < 4294967296)              // o.length < 2^32
        return true;                        // Then o is array-like
    else
        return false;                       // Otherwise it is not
}


// 验证是否为数组
function _isArray(obj){
    return Object.prototype.toString.call(obj).indexOf("object Array") !== -1 ? true : false;
}

// 生成数组
function _makeArray(obj){
    return !obj ? [] : (_isArray(obj) || _isArrayLike(obj)) ? obj : [obj];
}

var _addEventListener = (function(){
    var _events = document.addEventListener ? "addEventListener": "attachEvent";
    return function(el,type,fn){
        el[_events]((document.addEventListener ?"":"on")+type,fn);
    }
})();

var _removeEventListener=(function(){
    var _events = document.removeEventListener ? "removeEventListener" : "detachEvent";
    return function(el,type,fn){
        el[_events](type,fn);
    }
})();

/*
 * dom lazyLoad
 */
var lazyAttr = 'lazy-src';
var WH = document.addEventListener ? window.innerHeight :document.documentElement.offsetHeight;


function attr(el, name) {
    return el&&el.getAttribute(name);

}
function filter(elems) {
    return Array.prototype.filter.call(elems,function (el) {
        return !!attr(el, lazyAttr);
    }); //==> array
}




var LazyLoad = function (elems, offetTop, flag) {
    if(!elems)
    	console.log("elems 参数为空");
    // 重置属性
    lazyAttr = flag || lazyAttr ; 

    var els = filter(_makeArray(elems));

    var action = function () {

        els.forEach(function (el, i) {
            var elTop = el.getBoundingClientRect().top;//相对于窗口的高度，隐藏元素是0
            // fix  顶部
            var display = el.style.display == "none" ? false : true;

            var lazySrc = attr(el, lazyAttr);
            if (lazySrc && ((elTop  && elTop <= WH+(offetTop||0)) || (display&&elTop == 0))   ) {
               
                el.setAttribute('src', lazySrc);

                // 图片监控
                window.__image_cat&&window.__image_cat(el);

                el.removeAttribute(lazyAttr);
            }
        });
        els = filter(els);
        if (els.length <= 0) {
            _removeEventListener(window,"scroll",action);
            if(document.body)
                _removeEventListener(document.body,"touchmove",action);
        }
    };
    _addEventListener(window,"scroll",action);
    _addEventListener(window,"load",action);
    if(document.body)
        _addEventListener(document.body,"touchmove",action);

    // 立即执行
    action();
};


module.exports = LazyLoad;


// WEBPACK FOOTER //
// ./~/@dp/lazyload/dest/cortex.js